export type IResponseFeatureFlagsV2Api = {
  is_enable_new_design?: boolean
  sign_up_v2?: boolean
  salesmsg_design_v2_salesforce?: boolean
  salesmsg_design_v2_compliance_toll_free?: boolean
  salesmsg_design_v2_compliance_calling?: boolean
  webhook_setting?: boolean
  salesmsg_design_v2_calendly_page?: boolean
  hipaa_setting_toggle?: boolean
  salesmsg_design_v2_clients?: boolean
  chat_widget_setting_v2?: boolean
  url_shortener_design_v2?: boolean
}

export const updateDesignV2Api = (data: IResponseFeatureFlagsV2Api) => {
  if (!window.DesignV2API) return

  window.DesignV2API.init(data)
}
